import { createFileRoute, redirect } from "@tanstack/react-router";

/** 原型遗留 URL，只做跳转，不是页面。 */
export const Route = createFileRoute("/billing")({
  beforeLoad: () => {
    throw redirect({ to: "/settings" });
  },
});
